import React, {useEffect, useState} from "react";
import {Alert, Button, Col, Row} from "react-bootstrap";
import {getBanners, deleteBanner} from "../../Api/Banners/BannersFetch";
import BannersTable from "../../Components/Banners/BannersTable";
import BannerForm from "../../Components/Banners/BannerForm";
import {ConfirmationModal} from "../../Components/Modals/ConfirmationModal";
import {BsPlus} from "react-icons/bs";

const BannersList = () => {
    const [banners, setBanners] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [errors, setErrors] = useState(null);
    const [update, setUpdate] = useState(false);

    const [showForm, setShowForm] = useState(false);
    const [selectedBanner, setSelectedBanner] = useState(null);

    const [showConfirm, setShowConfirm] = useState(false);
    const [bannerToDelete, setBannerToDelete] = useState(null);

    useEffect(() => {
        getBanners({setBanners, setIsLoading, setErrors});
    }, [update]);

    const handleEdit = (banner) => {
        setSelectedBanner(banner);
        setShowForm(true);
    };

    const handleNew = () => {
        setSelectedBanner(null);
        setShowForm(true);
    };

    const handleDeleteRequest = (banner) => {
        setBannerToDelete(banner);
        setShowConfirm(true);
    };

    const handleDeleteConfirm = () => {
        deleteBanner({
            bannerId: bannerToDelete.id,
            setIsLoading,
            setErrors,
            setMessage,
            setShowConfirm,
            update,
            setUpdate,
        });
        setBannerToDelete(null);
    };

    return (
        <>
            <Row className={'mb-3 align-items-center'}>
                <Col>
                    <h2 className={'text-start mb-0'}>Banner Pubblicitari</h2>
                </Col>
                <Col className={'text-end'}>
                    <Button className={'bkg-second border-0'} onClick={handleNew}>
                        <BsPlus size={20}/> Nuovo Banner
                    </Button>
                </Col>
            </Row>

            {message && (
                <Alert variant={'success'} dismissible onClose={() => setMessage(null)}>
                    {message}
                </Alert>
            )}
            {errors && (
                <Alert variant={'danger'} dismissible onClose={() => setErrors(null)}>
                    {typeof errors === 'string' ? errors : JSON.stringify(errors)}
                </Alert>
            )}

            <Row>
                <Col md={12}>
                    <div className={'card border-0 shadow py-3 px-4'}>
                        {isLoading ? (
                            <p className={'text-muted'}>Caricamento...</p>
                        ) : (
                            <BannersTable
                                banners={banners}
                                onEdit={handleEdit}
                                onDelete={handleDeleteRequest}
                                update={update}
                                setUpdate={setUpdate}
                                setErrors={setErrors}
                            />
                        )}
                    </div>
                </Col>
            </Row>

            <BannerForm
                show={showForm}
                handleClose={() => setShowForm(false)}
                banner={selectedBanner}
                update={update}
                setUpdate={setUpdate}
                setMessage={setMessage}
            />

            <ConfirmationModal
                show={showConfirm}
                handleClose={() => setShowConfirm(false)}
                handleConfirm={handleDeleteConfirm}
                actionMessage={`Vuoi eliminare il banner "${bannerToDelete?.title}"?`}
            />
        </>
    );
};

export default BannersList;
